export default "/images/icon-calculate.png";